"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlastRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class BlastRequestDto {
  constructor() {
    this.openPeekToastOnClick = true;
  }
}
exports.BlastRequestDto = BlastRequestDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], BlastRequestDto.prototype, "message", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], BlastRequestDto.prototype, "radius", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], BlastRequestDto.prototype, "openPeekToastOnClick", void 0);
__decorate([(0, swagger_1.ApiPropertyOptional)({
  enum: ['none', 'venuePeek', 'eventsTab', 'upcomingEvent']
}), __metadata("design:type", String)], BlastRequestDto.prototype, "deepLinkTarget", void 0);
__decorate([(0, swagger_1.ApiPropertyOptional)(), __metadata("design:type", Object)], BlastRequestDto.prototype, "deepLinkVenueSpecialPublicId", void 0);
__decorate([(0, swagger_1.ApiPropertyOptional)(), __metadata("design:type", Object)], BlastRequestDto.prototype, "scheduledDate", void 0);
//# sourceMappingURL=BlastRequest.dto.js.map